"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = require("react");
var SvgBold = function SvgBold(props) {
  return React.createElement("svg", __assign({
    width: 1792,
    height: 1792,
    viewBox: "0 0 1792 1792"
  }, props), React.createElement("title", null, "bold"), React.createElement("g", {
    id: "a5473643-9da8-4ded-814a-fc4f596f9c7a",
    "data-name": "\\u30E9\\u30D9\\u30EB"
  }, React.createElement("path", {
    d: "M1455.78,430.37A532.41,532.41,0,0,1,1439.6,559.8,355.56,355.56,0,0,1,1386.09,678q-37.33,53.55-97.07,94.58t-144.35,61v14.94a585.31,585.31,0,0,1,141.86,42.31,364.25,364.25,0,0,1,117,82.13q49.76,52.27,78.4,126.93t28.62,176.72q0,134.4-57.24,232.71t-153.07,160.53q-95.84,62.23-217.78,92.09T831.07,1791.8H722.8q-66,0-141.87-3.74t-154.31-11.2q-78.39-7.47-143.11-22.4V37.13q47.25-7.47,108.27-14.94T522.45,9.75q69.64-5,143.11-7.47T811.16-.2a1491.47,1491.47,0,0,1,237.69,18.66q115.73,18.67,206.57,66T1401,216.33Q1455.74,301,1455.78,430.37Zm-734.22,326q34.82,0,80.89-2.45t75.91-7.39q94.56-29.52,163-88.67t68.44-155.17q0-64-24.89-105.89a188.49,188.49,0,0,0-66-66.5q-41.07-24.62-93.34-34.46A590.21,590.21,0,0,0,816.13,286q-64.74,0-119.46,2.49t-84.62,7.35V756.42Zm112,749.15a490.28,490.28,0,0,0,120.71-14.77q58.44-14.76,103.29-45.58a240.54,240.54,0,0,0,72.17-77.62q27.36-46.78,27.38-110.88,0-81.32-32.35-128.1t-84.63-72.68q-52.26-25.9-117-33.29a1146.62,1146.62,0,0,0-129.43-7.39H612.05V1490.8q12.42,5,39.82,7.38t58.49,3.7q31.08,1.27,64.71,2.49T833.56,1505.57Z"
  })));
};
exports.default = SvgBold;